import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Redirect, useParams } from "react-router";
import { Button } from "reactstrap";
import {
    DOWNLOAD_MEETING_FILES_URL,
    DOWNLOAD_MEETING_PACKETS_URL,
    GET_MEETING_BY_ID_URL,
    LOGIN_ROUTE,
    EDIT_MEETING_ROUTE
} from "../../constants";
import ProjectNavbar from "../widgets/projectNavbar";
import axios from "axios";
import SunEditor from "suneditor-react";
import "./../../styles/viewMeeting.css";
import { showMeetingHistory } from "../widgets/meetingHistory";
import { getMeetingHistory } from "../utils/getMeetingHistory";
import MeetingHeaderWithHistory from "../widgets/meetingHeaderWithHistory";
import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
import { getLocalTimeFromUTC } from "../utils/timeConverts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import ViewTopic from "../widgets/viewTopic";
import ViewAgenda from "../widgets/viewAgenda";

const ViewMeeting = () => {
    const jwt = useSelector((state) => state.authReducer.jwt);
    const currentUser = useSelector((state) => state.authReducer.currentUser);
    const { id } = useParams();
    const componentRef = useRef();

    const [meeting, setMeeting] = useState({
        name: null,
        title: null,
        date: null,
        start_time: null,
        end_time: null,
        topic_numbering: null,
        show_name_in_packet: true,
        show_title_in_packet: true,
        show_date_in_packet: true,
        items: [
            {
                description: null,
                order: null,
                is_active: null,
                minute: null,
                type: null,
            },
        ],
    });
    const [meetingHistory, setMeetingHistory] = useState(null);
    const [isShowMeetingHistory, setIsShowMeetingHistory] = useState(false);

    const location = useLocation()
    const {is_minutes} = location.state == null ? false : location.state;

    const fetchMeeting = async () => {
        const response = await axios.get(GET_MEETING_BY_ID_URL + `/${id}`, {
            headers: { Authorization: `Bearer ${jwt}` },
        });

        const startTime = getLocalTimeFromUTC(
            `${response.data.meeting.start_time}Z`,
            currentUser.current_client_timezone
        );
        response.data.meeting.start_time = startTime.toTimeString();
        response.data.meeting.date = startTime.toDateString();
        const endTime = getLocalTimeFromUTC(
            `${response.data.meeting.end_time}Z`
        );
        response.data.meeting.end_time = endTime.toTimeString();
        setMeeting(response.data.meeting);
    };

    useEffect(() => {
        fetchMeeting();
    }, []);

    return (
        <>
            {jwt === null ? (
                // if the user is not logged in then redirect to login
                <Redirect to={LOGIN_ROUTE} />
            ) : (
                <div className="container-lg">
                    <ProjectNavbar />
                    <div className="container-fluid">
                        <MeetingHeaderWithHistory
                            headingText="View Meeting"
                            getMeetingHistory={getMeetingHistory}
                            id={id}
                            jwt={jwt}
                            setMeetingHistory={setMeetingHistory}
                            setIsShowMeetingHistory={setIsShowMeetingHistory}
                            isShowMeetingHistory={isShowMeetingHistory}
                            showMeetingHistory={showMeetingHistory}
                            meetingHistory={meetingHistory}
                        />
                        <ReactToPrint
                            trigger={() => (
                                <Button color="success" className="float-end">
                                    Print / Download
                                </Button>
                            )}
                            content={() => componentRef.current}
                        />
                        <div id="edit-buttons">
                            <a
                                key={meeting.id}
                                href={EDIT_MEETING_ROUTE.replace(
                                    ":id",
                                    meeting.id
                                )}
                                className="btn-info btn"
                                >
                                    Edit Meeting
                                </a>
                            {meeting.is_finalized ?
                            <a
                                key={'download-' +meeting.id}
                                href={DOWNLOAD_MEETING_PACKETS_URL.replace(
                                    ":id",
                                    meeting.id
                                )}
                                className="btn-info btn"
                                >
                                    View Agenda Packet
                                </a> :
                                null
                            }
                        </div>
                        <div ref={componentRef} className="p-3">
                            <h2>Meeting Agenda</h2>
                            { (meeting.show_name_in_packet === 1
                                || meeting.show_title_in_packet === 1
                                || meeting.show_date_in_packet === 1
                            ) &&
                            <div class="mb-4">
                                { meeting.show_name_in_packet === 1 &&
                                    <p class="mb-0">
                                        <span className="fw-bold">Name: </span>{" "}
                                        {meeting.name}
                                    </p>
                                }
                                { meeting.show_title_in_packet === 1 &&
                                    <p class="mb-0">
                                        <span className="fw-bold">Title: </span>{" "}
                                        {meeting.title}
                                    </p>
                                }
                                { meeting.show_date_in_packet === 1 &&
                                    <div>
                                        <p class="mb-0">
                                            <span className="fw-bold">Date: </span>{" "}
                                            {meeting.date}
                                        </p>
                                        <p class="mb-0">
                                            <span className="fw-bold">Start Time: </span>{" "}
                                            {meeting.start_time}
                                        </p>
                                        <p class="mb-0">
                                            <span className="fw-bold">End Time: </span>{" "}
                                            {meeting.end_time}
                                        </p>
                                    </div>
                                }
                                </div>
                            }
                            {/* agendas */}
                            <div className="mb-2">
                                <ol type={meeting.topic_numbering} className={`${meeting.topic_numbering == null ? 'no-list' : ''}`}>
                                    {meeting.items.map((item, itemIndex) => {
                                        if(item.topic_parent_id !== null) return;
                                        return item.type === "AGENDA" ? (
                                            /* agenda */
                                            <ViewAgenda
                                                key={itemIndex}
                                                item={item}
                                            />
                                        ) : (
                                            /* topic */
                                            <ViewTopic
                                                key={itemIndex}
                                                item={item}
                                                itemIndex={itemIndex}
                                                meeting={meeting}
                                                is_minutes={is_minutes}
                                            />
                                        );
                                    })}
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ViewMeeting;
